import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IProject } from "./projects.interface";
import { ProjectsHttpService } from "./projects-http.service";
import { HttpService } from "../../../../http.service";
import { CompaniesService } from "../../companies-page/companies/companies.service";
import { ClientsService } from "../../clients-page/clients/clients.service";
import { AuthService } from "../../../shared/services/auth.service";
import { TaskHttpService } from "../../tasks-page/tasks/task-http.service";
import { QuotesHttpService } from "../../quotes-page/quotes/quotes-http.service";
import { BillingDocumentService } from "../../billing-documents-page/billing-documents/billing-documents.service";
import { DeliveryNotesService } from "../../delivery-notes-page/delivery-notes/delivery-notes.service";
import { TaskCommentService } from "../../tasks-page/tasks/task-comment/task-comment.service";
import { ITaskFilter } from "../../tasks-page/tasks/task.interface";
import { IFilter } from "../../../shared/interfaces/filter.interface";
import { ITaskCommentFilter } from "../../tasks-page/tasks/task-comment/task-comment.interface";
import { ICompany } from "../../companies-page/companies/companies.interface";

@Injectable()
export class ProjectsService {
  public http: ProjectsHttpService;

  constructor(
    private _http: HttpService,
    private _ProjectsHttpService: ProjectsHttpService,
    private _CompaniesService: CompaniesService,
    private _ClientsService: ClientsService,
    private _AuthService: AuthService,
    private _TaskHttpService: TaskHttpService,
    private _QuotesHttpService: QuotesHttpService,
    private _BillingDocumentService: BillingDocumentService,
    private _DeliveryNotesService: DeliveryNotesService,
    private _TaskCommentService: TaskCommentService,
  ) {
    this.http = this._ProjectsHttpService;
  }

  getProject(project: any): Observable<any> {
    return !(project && project._id) ? of(undefined) : this._ProjectsHttpService.getProject(project._id);
  }

  getClient(id: any): Observable<any> {
    return !id ? of(undefined) : this._ClientsService.getClient(id);
  }

  getTasksProject(filter: ITaskFilter): Observable<any> {
    return !filter ? of(undefined) : this._TaskHttpService.getTasks(filter);
  }

  getQuotesProject(filter: IFilter): Observable<any> {
    return !filter ? of(undefined) : this._QuotesHttpService.getQuotes(filter);
  }

  getInvoicesProject(filter: IFilter): Observable<any> {
    return !filter ? of(undefined) : this._BillingDocumentService.getBillingDocuments(filter as any);
  }

  getDeliveryNotesProject(filter: IFilter): Observable<any> {
    return !filter ? of(undefined) : this._DeliveryNotesService.getDeliveryNotes(filter);
  }

  getAttachmentsProject(filter: ITaskCommentFilter): Observable<any> {
    return !filter ? of(undefined) : this._TaskCommentService.getComments(filter);
  }

  getCompany(id: any): Observable<ICompany> {
    return !id ? of(undefined) : this._CompaniesService.getCompany(id);
  }

  createProject(project: IProject): Observable<IProject> {
    return this._ProjectsHttpService.createProject(project);
  }

  updateProject(project: IProject): Observable<IProject> {
    return this._ProjectsHttpService.updateProject(project);
  }

  deleteProject(project: IProject): Observable<any> {
    return !(project && project._id) ? of(undefined) : this._ProjectsHttpService.deleteProject(project);
  }

  restoreProject(project: IProject): Observable<any> {
    return !(project && project._id) ? of(undefined) : this._ProjectsHttpService.restoreProject(project);
  }
}